import { I18n } from '@ies/starling_intl';
import { message } from 'antd';
import { api } from '@/apis';

export function searchPermissions(key, id) {
  return new Promise(async resolve => {
    try {
      let flag = false;
      const data = await api.get(
        `/v1/access_control/right/check_right?project_id=${Number(
          id,
        )}&right_keys=${key}`,
      );
      if (data) {
        if (data[`${key}`]) {
          flag = true;
        } else {
          flag = false;
          api
            .get(`/v1/access_control/right/role?right_key=${key}`)
            .then(res => {
              if (res) {
                if (res.roles.length) {
                  const str = JSON.stringify([
                    'role_member',
                    'role_temporary_member',
                  ]);
                  // const {href} = router.resolve({path:`/role-permissions-apply/${Number(id)}/${str}`});
                  // window.open(href);
                  location.replace(
                    `/role-permissions-apply/${Number(id)}/${str}`,
                  );
                } else {
                  message.error(
                    I18n.t(
                      'no_permission!_please_contact_the_project_administrator_to_add_the_permission_of',
                      {},
                      '没有权限！请联系项目管理员添加商店提审负责人权限。',
                    ),
                    3,
                  );
                }
              }
            })
            .catch(err => {});
        }
      }
      resolve({
        flag,
      });
    } catch (err) {}
  });
}

export function OnlySearchPermissions(key, id) {
  return new Promise(async resolve => {
    try {
      let flag = false;
      const data = await api.get(
        `/v1/access_control/right/check_right?project_id=${Number(
          id,
        )}&right_keys=${key}`,
      );
      if (data) {
        if (data[`${key}`]) {
          flag = true;
        } else {
          flag = false;
          if (key.indexOf('right_project_common_role_change') !== -1) {
            message.error(
              I18n.t(
                'no_permission!_please_contact_the_project_owner_to_add_administrator_permissions',
                {},
                '没有权限！请联系项目owner添加管理员权限。',
              ),
              3,
            );
          } else if (key.indexOf('right_project_admin_role_change') !== -1) {
            message.error(
              I18n.t(
                'no_permission!_please_contact_the_project_owner_to_edit_',
                {},
                '没有权限！请联系项目owner编辑。',
              ),
              3,
            );
          } else if (
            key.indexOf('right_project_gp_ticket_qa_prereview') !== -1 ||
            key.indexOf('right_project_ios_ticket_qa_prereview') !== -1
          ) {
            message.error(
              I18n.t(
                'no_permission!_please_contact_the_project_administrator_to_add_the_qa_person_in_',
                {},
                '没有权限！请联系项目管理员添加QA负责人权限。',
              ),
              3,
            );
          } else {
            message.error(
              I18n.t(
                'no_permission!_please_contact_the_project_administrator_to_add_the_permission_of',
                {},
                '没有权限！请联系项目管理员添加商店提审负责人权限。',
              ),
              3,
            );
          }
        }
      }
      resolve({
        flag,
      });
    } catch (err) {}
  });
}
